import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Leilao02Component  } from './Leiloes/leilao02/leilao02.component';
import { HomeComponent } from './home/home.component';

import { Leilao01Component } from './Leiloes/leilao01/leilao01.component';
import { Leilao03Component } from './Leiloes/leilao03/leilao03.component';
import { Leilao04Component } from './Leiloes/leilao04/leilao04.component';
import { Leilao05Component } from './Leiloes/leilao05/leilao05.component';
import { Leilao06Component } from './Leiloes/leilao06/leilao06.component';
import { Leilao07Component } from './Leiloes/leilao07/leilao07.component';
import { Leilao08Component } from './Leiloes/leilao08/leilao08.component';
import { Leilao09Component } from './Leiloes/leilao09/leilao09.component'; 
import { Leilao10Component } from './Leiloes/leilao10/leilao10.component';
import { Leilao11Component } from './Leiloes/leilao11/leilao11.component';

const routes: Routes = [
  {
    path:'', component: HomeComponent
  },
  {
    path:'leilao01', component: Leilao01Component
  },
  {
    path: 'leilao02', component: Leilao02Component
  },
  {
    path: 'leilao03', component: Leilao03Component
  },
  {
    path: 'leilao04', component: Leilao04Component
  },
  {
    path: 'leilao05', component: Leilao05Component
  }, 
  {
    path: 'leilao06', component: Leilao06Component
  },
  {
    path: 'leilao07', component: Leilao07Component
  },
  {
    path: 'leilao08', component: Leilao08Component
  },
  {
    path: 'leilao09', component: Leilao09Component
  },
  {
    path: 'leilao10', component: Leilao10Component
  },
  {
    path: 'leilao11', component: Leilao11Component
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
